export default __webpack_public_path__ + "static/media/title-cn.3827a132.webp";